"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavRepeatSection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const graphql_1 = require("@app/gql-types/graphql");
const util_1 = require("@app/util");
const maybe_1 = require("@app/util/functional/maybe");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const modal_section_1 = require("./modal-section");
const UnavRepeatSection = () => {
    const { formControl, isEmployeeCalendar, isEditing, canEdit } = (0, unavailability_context_1.useUnavailability)();
    const [error, setError] = react_1.default.useState(undefined);
    const hasError = (0, util_1.isDefined)(error);
    const removeError = react_1.default.useCallback(() => setError(undefined), []);
    const recurrenceController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'recurrence',
    });
    const periodStartController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'period.start',
    });
    const canIEdit = isEmployeeCalendar ? !isEditing : canEdit;
    const disabledEditation = !(0, util_1.isValue)(periodStartController.field.value) || !canIEdit;
    const dayWord = (0, moment_1.default)(periodStartController.field.value).format('dddd');
    const repeatOptions = [
        {
            label: (0, util_1.t)('EVERY_WEEK_IN') + ' ' + dayWord,
            value: graphql_1.RecurrenceType.DayOfWeek,
            subValue: (periodStartController.field.value &&
                parseInt((0, moment_1.default)(periodStartController.field.value).format('d'))) ??
                1,
        },
        {
            label: (0, util_1.t)('EVERY_X_DAY_IN_MONTH', {
                x: periodStartController.field.value &&
                    parseInt((0, moment_1.default)(periodStartController.field.value).format('D')),
            }),
            value: graphql_1.RecurrenceType.DayOfMonth,
            subValue: (periodStartController.field.value &&
                parseInt((0, moment_1.default)(periodStartController.field.value).format('D'))) ??
                1,
        },
        {
            label: (0, util_1.t)('EVERY_14_DAYS') + ' ' + dayWord,
            value: graphql_1.RecurrenceType.EveryNDays,
            subValue: 14,
        },
    ];
    const validateDuration = ({ type, newDate }) => {
        const date = (0, moment_1.default)(newDate);
        const startDay = (0, moment_1.default)(periodStartController.field.value);
        const numberOfRepetitions = (type === 'dayOfWeek' && date.diff(startDay, 'week')) ||
            (type === 'dayOfMonth' && date.diff(startDay, 'month')) ||
            (type === 'everyNDays' && date.diff(startDay, 'month') * 2) ||
            0;
        if (Number(numberOfRepetitions) > 365) {
            setError('repeat-over-limit');
        }
        else {
            removeError();
        }
    };
    const untilWhenDateValue = new maybe_1.Maybe(recurrenceController.field.value?.until)
        .map((recurrence) => (0, moment_1.default)(recurrence).format('YYYY-MM-DD'))
        .get(() => undefined);
    return (react_1.default.createElement(modal_section_1.ModalSection, { id: 'repeat', cleanup: () => {
            recurrenceController.field.onChange(undefined);
        } },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(ui_1.Dropdown, { type: ui_1.Dropdown.TYPES.VARIABLE, style: ui_1.Dropdown.STYLES.LIGHT, size: ui_1.Dropdown.SIZES.FULL_WIDTH, singleSelect: true, disableSort: true, disabled: disabledEditation, label: (0, util_1.t)('REPEAT'), value: repeatOptions.find((item) => item.value === recurrenceController.field.value?.type), options: repeatOptions, onChange: (option) => {
                    validateDuration({
                        type: option.value,
                        newDate: recurrenceController.field.value?.until,
                    });
                    recurrenceController.field.onChange({
                        ...recurrenceController.field.value,
                        type: option.value,
                        value: option.subValue,
                    });
                } }),
            react_1.default.createElement(ui_1.Input, { size: ui_1.Input.SIZES.FULL_WIDTH, label: (0, util_1.t)('UNTIL_WHEN'), type: 'date', disabled: disabledEditation, onChange: (v) => {
                    validateDuration({
                        type: recurrenceController.field.value?.type,
                        newDate: v,
                    });
                    recurrenceController.field.onChange({
                        ...recurrenceController.field.value,
                        until: (0, moment_1.default)(v).format(),
                    });
                }, value: untilWhenDateValue })),
        hasError && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_6 }),
            react_1.default.createElement(ui_1.Alert, { text: (0, util_1.t)('CANT_CREATE_365_REPEATS'), type: ui_1.Alert.TYPES.ERROR, size: ui_1.Alert.SIZES.FULL_WIDTH })))));
};
exports.UnavRepeatSection = UnavRepeatSection;
